<template>
<v-card class='grey lighten-4 pb-5' flat >
  <!-- <v-card-title class='subtitle-1 overline' >
  </v-card-title> -->
  <!-- <v-btn @click='getRemoteRelationship(relationshipId)' ></v-btn> -->
  <tombstone v-if='request.loading' ></tombstone>
  <transition v-else name='fade' appear >
    <v-card class='mx-2 mt-2' >
      <!-- ## {{relationshipId}} / {{relationship}} -->
      <client-contact-details
        v-if='relationship && relationship.client'
        v-model='relationship'
        :touch='touch'
        :relationship-id='relationshipId'
        :with-edit='true'
        :with-fetch='false' >
      </client-contact-details>
      <v-footer class='pl-3' >
        <sharing-information v-if='ownerId'
          :context='relationship.context'
          :owner-id='ownerId'
          :space-ids='relationship.spaces'
          @click='$emit("click:share", relationship)' />
        <v-spacer/>
        <v-btn small icon @click='initPage' >
          <v-icon small>replay</v-icon>
        </v-btn>
      </v-footer>
    </v-card>
  </transition>

  <!-- meta info and stats -->
  <tombstone v-if='request.loading' height='300px' ></tombstone>
  <transition v-else name='fade' appear >
    <v-layout v-if = 'relationship && relationship.computed_summary' wrap >
      <v-flex xs12 sm6 >
        <v-card height='100%' v-if='relationship.computed_summary.dates' class='ma-2' >
          <v-card-text>
            <div v-if='formattedBio' >
              <v-subheader class='pl-0 overline' >Bio</v-subheader>
              <p v-html="formattedBio" ></p>
            </div>
            <v-divider class='mb-3' v-if='record && record.patient && record.patient.notes' ></v-divider>
            <v-subheader class='pl-0 overline' >Highlights</v-subheader>
            <div >First appointment:
              <span style='float:right' v-if='relationship.computed_summary.dates.first' >
              {{dateformat(relationship.computed_summary.dates.first)}}
              </span>
              <span v-else style='float:right' >None yet</span>
            </div>
            <div>Total appointments:
              <span style='float:right' >
              {{relationship.computed_summary.dates.count}}
              </span>
            </div>
            <template v-if='record && record.patient' >
              <div>
                Birthday:
                <span style='float:right' >
                {{ record.patient.date_of_birth || 'unknown' }}
                <span v-if='record.patient.date_of_birth' >
                  ({{age}} years old)
                </span>
                </span>
              </div>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 >
        <v-card height='100%' v-if='relationship.computed_summary.account' class='ma-2' >
          <v-progress-linear
            v-if='relationship.computed_summary.account.percent_paid <= 100'
            :value="relationship.computed_summary.account.percent_paid"
            color='amber'
            class='ma-0' >
          </v-progress-linear>
          <v-progress-linear v-else :value="100" color='success' class='ma-0' >
          </v-progress-linear>
          <v-card-title class='subtitle-1 overline  pb-0' >
            Account
            <v-spacer></v-spacer>
            <help-popover>
              These numbers are calculated based on the appointments in this account.

              <v-subheader class='pa-0 overline'>Payments received</v-subheader>
              This is the sum of all payments tracked against this user's appointments

              <v-subheader class='pa-0 overline'>Due</v-subheader>
              This is <i>payments received</i> - <i>Total value of appointments to date</i>

              <br/><b>Note:</b> Future appointments are not considered "due"
            </help-popover>
          </v-card-title>
          <v-card-text>
            <div>Total value of appointments to date:
              <span style='float:right' >
              {{ formatnumber(relationship.computed_summary.account.value_past, true) }}
              </span>
            </div>
            <div>Total value of future appointments:
              <span style='float:right' >
              {{ formatnumber(relationship.computed_summary.account.value_future, true) }}
              </span>
            </div>
            <div>
              Payments received:
              <span style='float:right' >
                {{ formatnumber(relationship.computed_summary.account.payments, true) }}
              </span>
            </div>
            <v-divider></v-divider>
            <div>
              Due:
              <strong style='float:right' >
                {{ formatnumber(relationship.computed_summary.account.value_outstanding, true) }}
              </strong>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </transition>

  <v-flex v-if = 'isMedical && relationship' >
    <v-list dense subheader three-line class='mt-3 mx-2 elevation-2'
      v-if='relationship.active_codes && relationship.active_codes.length > 0' >
      <v-subheader class='overline' >
        Current treatment codes
        <v-spacer></v-spacer>
        <v-btn outline outlined small class='mr-0'
          color='primary'
          @click='$emit("goto", "codes")' >
          Manage codes
          <v-icon class='ml-2' small >open_in_new</v-icon>
        </v-btn>
      </v-subheader>
      <treatment-log-list-item
        v-for='code in relationship.active_codes'
        :item='code'
        :key='code.id'
        :with-delete=false >
      </treatment-log-list-item>
    </v-list>
    <v-card v-else class='mx-2 my-4'>
      <v-card-title class='overline' >
        No treatment codes defined
        <v-spacer></v-spacer>
        <v-btn
            href='https://www.loom.com/share/f26d5537be0540f7bd8fc82c61b9b6f6'
            target='_blank'
            color='primary' small outline outlined >
              Learn more
              <v-icon class='ml-2' small >open_in_new</v-icon>
        </v-btn>
        <v-btn outline outlined small class='mr-0'
          color='primary'
          @click='$emit("goto", "codes")' >
          Manage codes
          <v-icon class='ml-2' small >open_in_new</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-icon small color='primary' >info</v-icon>
        You can define treatment codes for a client and optionally have them automatically added to new
        appointments.
      </v-card-text>
    </v-card>
  </v-flex>

  <tombstone v-if='request.loading' height='300px' ></tombstone>
  <transition v-else name='fade' appear >
    <v-layout row wrap >
      <v-flex xs12 >
        <v-subheader class='overline py-0 mt-3' >
          Details as they will show on invoices
          <v-spacer></v-spacer>
          <v-btn outline outlined small
            color='primary'
            @click='$emit("goto", "record")' >
            Edit
            <v-icon class='ml-2' small >open_in_new</v-icon>
          </v-btn>
          <!--
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :to='`https://invoiceguru.appointmentguru.co/preview/relationship/${relationship.id}/`'
                target='_blank'
                v-on="on" small icon ><v-icon small>open_in_new</v-icon></v-btn>
            </template>
            <span>See an example invoice</span>
          </v-tooltip> -->

        </v-subheader>
      </v-flex>
      <v-flex xs12 :sm6='isMedical' >
        <v-card height='100%' class='ma-2' v-if='relationship && relationship.client && record' >
          <v-card-title class='subtitle-1 overline pb-0' >
            Billing information
            <v-spacer></v-spacer>
            <!-- <v-btn
              small outline outlined color='primary' >
              Client info <v-icon small class='ml-1' >open_in_new</v-icon>
            </v-btn> -->
          </v-card-title>
          <div class='pa-3' >
          <template v-if = 'record && record.patient && record.patient.billing_address' >
            <pre style='font-family:Roboto'>{{record.patient.billing_address}}</pre>
          </template>
          <template v-else >
            {{relationship.client.first_name}}
            {{relationship.client.last_name}}<br/>
            <span v-if='isRealEmail(relationship.client.email)' >
              Email: {{relationship.client.email}}<br/>
            </span>
            <span v-if='relationship.client.phone_number' >
            Phone: {{relationship.client.phone_number}}<br/>
            </span>
          </template>
          </div>
        </v-card>
      </v-flex>
      <v-flex v-if='isMedical' xs12 sm6 >
        <v-card height='100%' class='ma-2' v-if='medicalaid' >
          <v-card-title class='subtitle-1 overline pb-0' >
            Medical Aid information
          </v-card-title>
          <div class='pa-3' >
            <strong>{{medicalaid.name || 'No medical aid specified'}}</strong>
            <small v-if='medicalaid.scheme' >({{medicalaid.scheme}})</small><br/>
            <strong>Membership #:</strong> {{medicalaid.number}}<br/>
            <strong>Patient:</strong> {{medicalaid.patient_first_name}} {{medicalaid.patient_last_name}}<br/>
            <strong>ID:</strong> {{medicalaid.patient_id_number}}
            <div v-if='medicalaid.is_dependent' >
            <strong>Main member:</strong> {{medicalaid.member_first_name}} {{medicalaid.member_last_name}}<br/>
            <strong>ID:</strong> {{medicalaid.member_id_number}}
            </div>
            <div v-else >
              <v-icon small color='success' >check_circle</v-icon>
              Patient is main member
            </div>
          </div>
          <v-list dense v-if='currentReferrers' >
            <v-subheader class='overline' >Referred by:</v-subheader>
            <v-list-tile v-for='referrer in currentReferrers' :key='referrer.id' >
              <v-list-tile-content v-if='referrer.therapist'>
                <v-list-tile-title>
                  {{referrer.therapist.title}} {{referrer.therapist.first_name}} {{referrer.therapist.last_name}}.
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                {{referrer.therapist.reference_number}}
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </transition>
  <v-card v-if='relationship && relationship.client' class='ma-2 mt-4' >
      <v-card-title class='subtitle-1 overline' >
        Danger Zone
      </v-card-title>
      <v-card-actions >
        <v-dialog width='300' v-model='del.showConfirmation' >
          <v-window v-model="del.window" vertical touchless >
            <v-window-item >
               <v-card>
                <v-card-title class='subtitle-1 overline' >
                </v-card-title>
                <v-card-text >
                  <center>
                    Are you sure you want to <strong>archive</strong>
                    <blockquote class="blockquote pa-0 mt-2">
                      {{relationship.client.first_name}} {{relationship.client.last_name}}
                    </blockquote>
                    <v-divider class='mt-2'></v-divider>
                    <v-checkbox hide-details v-model='del.permanent' class='mt-3 pa-0' label='Permanently delete' ></v-checkbox>
                    <v-checkbox hide-details v-model='del.withAppointments' class='pa-0' label='Also delete their appointments' ></v-checkbox>
                  </center>
                </v-card-text>
                <v-card-actions >
                  <v-btn flat text @click='del.showConfirmation=false' >
                    Cancel
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn v-if='del.permanent'
                    @click='deleteRelationship(relationship.id)'
                    :loading='deleteRequest.loading' color='error' >Delete</v-btn>
                  <v-btn v-else
                    @click='deleteRelationship(relationship.id)'
                    :loading='deleteRequest.loading' color='warning' >Archive</v-btn>
                </v-card-actions>
              </v-card>
            </v-window-item >
            <v-window-item >
              <v-card>
                <v-card-text>
                  <center>
                    <v-icon color='green' size='72' >check_circle</v-icon>
                    <blockquote class='blockquote pa-0 mt-2' >
                      Successfully archived
                    </blockquote>
                  </center>
                </v-card-text>
                <v-card-actions >
                  <v-btn to='/clients' @click='del.window=0;del.showConfirmation=false' flat text >Done</v-btn>
                </v-card-actions>
              </v-card>
            </v-window-item >
          </v-window>
        </v-dialog >
        <v-btn
          @click='del.showConfirmation = true;del.window=0'
          :disabled='!isOwner'
          :loading='deleteRequest.loading' color='error' >Delete</v-btn>

        <!-- <v-btn
          v-if='relationshipId'
          :to='`/clients/merge/${relationshipId}`' color='warning' >Merge client</v-btn> -->
      </v-card-actions >
      <p v-if='!isOwner' class='caption mx-2'>
        <v-icon small >info</v-icon>
        Only the owner can delete this client
      </p>
    </v-card>

  <!-- <v-subheader class='overline' >Current treatment plan</v-subheader> -->
  <!-- <pre>{{relationship}}</pre> -->
</v-card>
</template>
<script>
import {DateTime} from 'luxon'
import {GET_CLIENT_RELATIONSHIP_REQUEST} from '@/store/constants'
import ClientContactDetails from '@/components/client/ClientContactDetails'
import Tombstone from '@/components/app/Tombstone'
import TreatmentLogListItem from '@/components/medicalaid/TreatmentLogListItem'
import HelpPopover from '@/components/ui/HelpPopover'
import SharingInformation from '@/components/ui/SharingInformation.vue'

import marked from 'marked'

export default {
  name: 'ClientIndex',
  props: {
    relationshipId: { type: Number, required: true },
    touch: { type: Number, default: 1 }
  },
  components: {
    ClientContactDetails,
    TreatmentLogListItem,
    SharingInformation,
    HelpPopover,
    Tombstone
  },
  data () {
    return {
      del: {
        showConfirmation: false,
        reqId: 'delete-client-request',
        permanent: false,
        withAppointments: false
      }
    }
  },
  methods: {
    initPage () {
      if (this.relationshipId) {
        this.getRemoteRelationship(this.relationshipId)
      }
    },
    deleteRelationship (id) {
      let params = {}
      if (this.del.withAppointments) {
        params['delete_appointments'] = this.del.withAppointments
      }
      if (this.del.permanent) {
        params['permanent'] = this.del.permanent
      }
      this.$appointmentguru
        .resource('practitioner.clients')
        .id(this.del.reqId)
        .delete(id, params)
    }
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler () {
        this.initPage()
      }
    },
    touch () {
      this.initPage()
    },
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        // console.log(this.relationship)
        this.$store.commit('deleteClient', this.relationship)
        let vm = this
        vm.del.window = 1
        setTimeout(() => {
          vm.del.showConfirmation = false
          vm.del.window = 0
          vm.$emit('close')
          vm.$router.push({path: '/clients'})
        }, 1000)
      }
    }
  },
  computed: {
    isOwner () {
      if (this.relationship && this.relationship.owner && this.relationship.owner.id) {
        return parseInt(this.relationship.owner.id) === parseInt(this.meId)
      }
      return false
    },
    ownerId () {
      return this.getObjectPath(this.relationship, 'owner.id')
    },
    record () {
      let record = this.getObjectPath(this.relationship, 'record', {})
      if (record.status && record.status !== 200) {
        return {}
      }
      return record
    },
    formattedBio () {
      if (this.record) {
        marked.setOptions({sanitize: true})
        let bio = this.getObjectPath(this.record, 'patient.notes')
        if (bio) {
          return marked(bio)
        }
      }
      return null
    },
    deleteRequest () {
      return this.$store.getters.getRequestById(this.del.reqId, true)
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    },
    percentPaid () {
      let total = parseFloat(this.getObjectPath(this.relationship, 'computed_meta.financials.grand_total', 0))
      let received = parseFloat(this.getObjectPath(this.relationship, 'computed_meta.financials.payments_received', 0))
      if (total === 0) { return 100 }
      return Math.round(received / total * 100)
    },
    medicalaid () {
      if (this.record) { return this.record.medical_aid }
    },
    birthday () {
      return this.getObjectPath(this.record, 'patient.date_of_birth')
    },
    age () {
      if (this.birthday) {
        let today = DateTime.local()
        let bday = DateTime.fromISO(this.birthday)
        return Math.floor(today.diff(bday).as('years'))
      }
      return null
    },
    request () {
      return this.$store.getters.getRequestById(GET_CLIENT_RELATIONSHIP_REQUEST)
    },
    relationship: {
      get () {
        return this.getObjectPath(this.request, 'result.data', {})
      },
      set (newVal) {
        this.$store.commit('addClient', newVal)
      }
    },
    currentReferrers () {
      if (this.record && this.record.referrers && this.record.referrers.length > 0) {
        let referrers = this.record.referrers
        let currentReferrers = referrers.filter((item) => {
          return item.is_current_referrer
        })
        if (currentReferrers && currentReferrers.length > 0) {
          return currentReferrers
        }
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientIndex.vue?6465286b